module.exports = __webpack_public_path__ + "img/physical-radio.1fdf23ff.png";